export default class Locale_HelpSection {
	Info: string = "Info";
	FAQ: string = "FAQ";
	Videos: string = "Videos";
	Support: string = "Support";
}